(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-announcement')) {
    class ZvAnnouncement extends HTMLElement {
      connectedCallback() {
        this.messages = [...this.querySelectorAll('.zv-ann__msg')];
        if (this.messages.length < 2) return;
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.paused = false;

        this.querySelectorAll('.zv-ann__arrow').forEach((button) =>
          button.addEventListener('click', () => {
            this.go(this.index + Number(button.dataset.dir));
            this.restart();
          })
        );

        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => (this.paused = true)));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => (this.paused = false)));

        this.restart();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      restart() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.go(this.index + 1);
        }, this.interval);
      }

      go(next) {
        const total = this.messages.length;
        const current = this.messages[this.index];
        this.index = (next + total) % total;
        const target = this.messages[this.index];
        current.classList.remove('is-active');
        current.hidden = true;
        target.hidden = false;
        target.classList.add('is-active');
      }
    }
    customElements.define('zv-announcement', ZvAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-home-hediye"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-gift-finder')) {
    class ZvGiftFinder extends HTMLElement {
      connectedCallback() {
        this.choice = { who: null, style: null };
        this.matches = [...this.querySelectorAll('.zv-gift__match')];
        this.hint = this.querySelector('[data-hint]');
        this.reset = this.querySelector('[data-reset]');

        this.querySelectorAll('.zv-gift__step').forEach((step) => {
          step.addEventListener('click', (event) => {
            const chip = event.target.closest('.zv-chip');
            if (!chip) return;
            step.querySelectorAll('.zv-chip').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
            this.choice[step.dataset.step] = chip.dataset.value.toLocaleLowerCase('tr');
            this.update();
          });
        });

        this.reset?.addEventListener('click', () => {
          this.choice = { who: null, style: null };
          this.querySelectorAll('.zv-chip').forEach((c) => c.setAttribute('aria-pressed', 'false'));
          this.update();
          this.querySelector('.zv-chip')?.focus();
        });
      }

      update() {
        const { who, style } = this.choice;
        const ready = who && style;
        this.hint.hidden = Boolean(ready);
        if (this.reset) this.reset.hidden = !(who || style);
        this.matches.forEach((m) => (m.hidden = true));
        if (!ready || !this.matches.length) return;

        const tags = (value) => value.split(',').map((t) => t.trim().toLocaleLowerCase('tr')).filter(Boolean);
        let best = this.matches[0];
        let bestScore = -1;
        for (const match of this.matches) {
          const score = (tags(match.dataset.style).includes(style) ? 2 : 0) + (tags(match.dataset.who).includes(who) ? 1 : 0);
          if (score > bestScore) {
            best = match;
            bestScore = score;
          }
        }
        best.hidden = false;
      }
    }
    customElements.define('zv-gift-finder', ZvGiftFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-home-renk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-color-mood')) {
    class ZvColorMood extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (!(event.key in keys)) return;
            event.preventDefault();
            const next = (i + keys[event.key] + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          const copy = this.querySelector(`[data-copy="${tab.getAttribute('aria-controls').replace('ZvMoodPanel-', '')}"]`);
          [panel, copy].forEach((el) => {
            if (!el) return;
            el.hidden = !active;
            el.classList.toggle('is-active', active);
          });
          if (active) {
            this.style.setProperty('--mood-bg', tab.dataset.bg);
            this.style.setProperty('--mood-fg', tab.dataset.fg);
          }
        });
      }
    }
    customElements.define('zv-color-mood', ZvColorMood);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-urun-gorseller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-slider')) {
    class ZvSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.zv-shots__track');
        this.bar = this.querySelector('.zv-shots__progress span');
        this.arrows = [...this.querySelectorAll('.zv-shots__arrow')];
        this.arrows.forEach((a) =>
          a.addEventListener('click', () => {
            const item = this.track.querySelector('.zv-shots__item');
            const step = item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
            this.track.scrollBy({ left: step * Number(a.dataset.dir), behavior: 'smooth' });
          })
        );
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update(), { passive: true });
        this.update();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(1, scrollWidth - clientWidth);
        const visible = Math.min(100, (clientWidth / scrollWidth) * 100);
        this.bar?.style.setProperty('--p', `${visible}%`);
        this.bar?.style.setProperty('--o', `${(scrollLeft / max) * (100 - visible)}%`);
        if (this.arrows.length) {
          this.arrows[0].disabled = scrollLeft <= 2;
          this.arrows[1].disabled = scrollLeft >= max - 2;
        }
      }
    }
    customElements.define('zv-slider', ZvSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-urun-parcalar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-kit')) {
    class ZvKit extends HTMLElement {
      connectedCallback() {
        this.tools = [...this.querySelectorAll('.zv-kit__tool')];
        this.parts = [...this.querySelectorAll('.zv-kit__part')];

        this.parts.forEach((part) => {
          const on = () => this.highlight(part.dataset.part);
          part.addEventListener('mouseenter', on);
          part.addEventListener('focus', on);
          part.addEventListener('click', () => {
            const same = this.dataset.active === part.dataset.part;
            same ? this.highlight(null) : on();
          });
        });
        this.querySelector('.zv-kit__list')?.addEventListener('mouseleave', () => this.highlight(null));

        this.querySelectorAll('.zv-kit__color').forEach((btn) =>
          btn.addEventListener('click', () => {
            this.querySelectorAll('.zv-kit__color').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
            this.style.setProperty('--kit-case', btn.dataset.case);
            this.style.setProperty('--kit-tool', btn.dataset.tool);
          })
        );
      }

      highlight(id) {
        if (id) this.dataset.active = id;
        else delete this.dataset.active;
        this.tools.forEach((t) => t.classList.toggle('is-active', t.dataset.part === id));
        this.parts.forEach((p) => p.classList.toggle('is-active', p.dataset.part === id));
      }
    }
    customElements.define('zv-kit', ZvKit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zappyvibe-urun-sizden"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-reels')) {
    class ZvReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.zv-reels__track');
        this.querySelectorAll('.zv-reels__arrow').forEach((a) =>
          a.addEventListener('click', () => {
            const card = this.track.querySelector('.zv-reel');
            const step = card ? card.getBoundingClientRect().width + 14 : 300;
            this.track.scrollBy({ left: step * Number(a.dataset.dir), behavior: 'smooth' });
          })
        );

        this.videos = [...this.querySelectorAll('.zv-reel__video')];

        // Videolar her zaman sessiz; ses hiçbir şekilde açılmaz
        this.videos.forEach((v) => {
          v.muted = true;
          v.defaultMuted = true;
          v.volume = 0;
          v.addEventListener('volumechange', () => {
            if (!v.muted) v.muted = true;
          });
        });

        // Otomatik oynat; ekran dışındayken durdur, geri gelince devam et
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              for (const e of entries) {
                if (e.isIntersecting) e.target.play().catch(() => {});
                else e.target.pause();
              }
            },
            { threshold: 0.25 }
          );
          this.videos.forEach((v) => this.io.observe(v));
        } else {
          this.videos.forEach((v) => v.play().catch(() => {}));
        }
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }
    }
    customElements.define('zv-reels', ZvReels);
  }

  } catch(e) { console.error(e); }
})();
})();
